if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.originalButtonText = "";
        this.persistentTextActive = false;
      }

      connectedCallback() {
        setTimeout(() => {
          this.form = this.querySelector("form");
          if (!this.form) return;

          const variantInput = this.variantIdInput;
          if (variantInput) variantInput.disabled = false;

          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
          // EVORA: do NOT assign this.cart — we always redirect to checkout
          this.cart = null;
          this.submitButton = this.querySelector('[type="submit"]');
          if (!this.submitButton) return;

          this.submitButtonText = this.submitButton.querySelector(".button-text");
          if (this.submitButtonText) {
            this.originalButtonText = this.submitButtonText.textContent;
            this.submitButton.dataset.originalText = this.originalButtonText;
          }

          if (this.submitButton.classList.contains("has-persistent-text") && this.submitButtonText) {
            this.persistentTextActive = true;
            const persistentText = this.submitButton.dataset.persistentText;
            if (persistentText) {
              this.submitButtonText.textContent = persistentText;
              localStorage.setItem("addToCartButtonText", persistentText);
            } else {
              const storedText = localStorage.getItem("addToCartButtonText");
              if (storedText) {
                this.submitButtonText.textContent = storedText;
                this.submitButton.dataset.persistentText = storedText;
              }
            }
          }

          this.hideErrors = this.dataset.hideErrors === "true";
          document.addEventListener("variant:change", this.handleVariantChange.bind(this));
        }, 100);
      }

      handleVariantChange(event) {
        if (!this.submitButtonText) return;
        setTimeout(() => {
          if (this.persistentTextActive) {
            const persistentText = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
            if (persistentText) this.submitButtonText.textContent = persistentText;
          }
        }, 50);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        const spinner = this.querySelector(".loading__spinner");
        if (spinner) spinner.classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        config.body = formData;

        // Clear cart first, then add, then redirect straight to checkout
        fetch('/cart/clear.js', { method: 'POST' })
          .then(() => fetch(routes.cart_add_url, config))
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              if (this.submitButtonText) this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            }
            // EVORA: always redirect to checkout — no cart drawer
            window.location.href = '/checkout';
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (spinner) spinner.classList.add("hidden");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            if (!this.error && this.persistentTextActive) {
              const persistentText = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
              if (persistentText && this.submitButtonText) {
                this.submitButtonText.textContent = persistentText;
              }
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");
        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
        if (errorMessage) this.errorMessage.textContent = errorMessage;
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          if (this.persistentTextActive) {
            const persistentText = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
            if (persistentText) { this.submitButtonText.textContent = persistentText; return; }
          }
          if (this.originalButtonText) {
            this.submitButtonText.textContent = this.originalButtonText;
          } else if (this.submitButton.dataset.originalText) {
            this.submitButtonText.textContent = this.submitButton.dataset.originalText;
          } else {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      disconnectedCallback() {
        document.removeEventListener("variant:change", this.handleVariantChange);
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
